import * as Config from '../../configs/server.configs';

export const endPoint = Config[process.env.NODE_ENV].server + '/api/';
export const bankEndPoint = Config[process.env.NODE_ENV].bankEndPoint;
export const endPointOryton = Config[process.env.NODE_ENV].orytonEndPoint;
export const endPointAccount = Config[process.env.NODE_ENV].ACCOUNT_API + '/api';
export const endPointEHF = Config[process.env.NODE_ENV].ehfEndpoint + '/api';
export const endPointTask = Config[process.env.NODE_ENV].taskEndpoint + '/api';
export const endpointTrackingBank = Config[process.env.NODE_ENV].trackingBankEndpoint + '/api';
export const endpointStatistic = Config[process.env.NODE_ENV].statisticsEndpoint + '/api';
export const endpointMail = Config[process.env.NODE_ENV].mailServerEndpoint;
export const endpointZtl = Config[process.env.NODE_ENV].ztlEndpoint + '/api';
export const endpointVoucherAI = Config[process.env.NODE_ENV].voucherAIEndpoint + '/api';
export const endpointTripletex = Config[process.env.NODE_ENV].tripletexEndpoint + '/api';
export const loggingEndpoint = Config[process.env.NODE_ENV].loggingEndpoint + '/api';
export const endPointInvoice = Config[process.env.NODE_ENV].invoiceEndPoint + '/bilagsky-gateway';
